import { render, staticRenderFns } from "./EstadisticaReporte.vue?vue&type=template&id=7706a478&scoped=true"
import script from "./EstadisticaReporte.vue?vue&type=script&lang=js"
export * from "./EstadisticaReporte.vue?vue&type=script&lang=js"
import style0 from "./EstadisticaReporte.vue?vue&type=style&index=0&id=7706a478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7706a478",
  null
  
)

export default component.exports